import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { hasValue } from './app/angular-core/utils/functions/common.functions';

const LEGACY_SUBDOMAIN = "xperience";
const NEW_SUBDOMAIN = "portal";

const hostParts = window.location.hostname.split('.');
if (hostParts.length === 3 && hostParts[0] === LEGACY_SUBDOMAIN) {
  // Force a client side redirect, this will cause a page reload!
  hostParts[0] = NEW_SUBDOMAIN;
  window.location.hostname = hostParts.join('.');
}

if (hasValue(environment.googleAnalyticsId) && environment.googleAnalyticsId.length > 0) {
  const consentScript = document.createElement('script');
  consentScript.innerHTML = `
  window.dataLayer = window.dataLayer || [];
  function gtag() { dataLayer.push(arguments); }

  gtag('consent', 'default', {
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'analytics_storage': 'denied',
  });
  `;

  const loadScript = document.createElement('script');
  loadScript.async = true;
  loadScript.src = `https://www.googletagmanager.com/gtag/js?id=${environment.googleAnalyticsId}`;

  const configScript = document.createElement('script');
  configScript.innerHTML = `
  window.dataLayer = window.dataLayer || [];
  function gtag() { dataLayer.push(arguments); }
  gtag('js', new Date());

  gtag('config', '${environment.googleAnalyticsId}');
  `;

  document.head.after(consentScript, loadScript, configScript);
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
